<form [formGroup]="selectedFormGroup" (ngSubmit)="onSubmit()">
    <div *ngFor="let rows of inputForm" class="row justify-content-center">
        <div *ngFor="let col of rows['cols']" [class]="col['class']">
            <!-- INPUTS -->
            <!-- Title -->
            <h2 *ngIf="col.title" [class]="col['titleClass']">
                {{ col.title.toUpperCase() }}
            </h2>
            <!-- Subtitle -->
            <h3 *ngIf="col['subtitle']" [class]="col['subtitleClass']">
                {{ col['subtitle'] }}
            </h3>
            <div class="form-group" *ngIf="col.item == 'input' && !col['subtype']">
                <!-- Label -->
                <label [attr.for]="col['formControlName']">
                    {{ col['label'] }}
                </label>
                <!-- Input -->
                <input [type]="col.type" *ngIf="col.item == 'input' && !col['subtype']"
                       [attr.placeholder]="col?.placeholder?.toUpperCase()"
                       [class]="col['inputClass']"  [formControlName]="col['formControlName']"
                       [id]="col['formControlName']">
            </div>
            <!-- Select provinces-->
            <span *ngIf="col.item == 'select'">
                 <label [attr.for]="col['formControlName']">
                    {{ col['label'] }}
                </label>
                 <select name="provinces" id="provinces" class="form-control" *ngIf="col.item == 'select' &&
                col['type'] == 'provinces'" [formControlName]="col['formControlName']">
                     <option [ngValue]="province" *ngFor="let province of provinces"> {{ province }}</option>
                </select>
            </span>
            <!-- reCaptcha-->
            <div class="recaptcha-container" *ngIf="col['item'] == 'recaptcha'">
                <re-captcha formControlName="recaptcha" [siteKey]="apiKey"></re-captcha>
            </div>
            <!-- Button -->
            <div *ngIf="col.item == 'button' && col['type'] != 'info' && col['submit'] != 'true'"
                 [class]="col['inputClass']" (click)="this[col['buttonAction']]()">
                {{ col.placeholder.toUpperCase() }}
            </div>
            <!-- Submit Button -->
            <button type="submit" *ngIf="col.item == 'button' && col['type'] != 'info' && col['submit'] == 'true'"
                    [class]="col['inputClass']">
                {{ col.placeholder.toUpperCase() }}
            </button>
            <!-- Link -->
            <a *ngIf="col.item == 'a'" [class]="col['inputClass']" (click)="this[col['buttonAction']]()">
                {{ col.placeholder }}
            </a>

            <!-- ERROR WARNINGS -->
            <div
                *ngIf="(col.item == 'input' || col.item == 'recaptcha')  &&
                form[col['formControlName']].invalid
                && (
                form[col['formControlName']].dirty || form[col['formControlName']].touched)"
                class="error-warning" [ngClass]="{'mt-0' : col.item ==
                'recaptcha'}">
                <!-- Required -->
                <div *ngIf="form[col['formControlName']].errors.required">
                    Es requerido
                </div>
                <!-- Email -->
                <div *ngIf="form[col['formControlName']].status ==
                    'INVALID' && col['type'] == 'email'">
                    Debes introducir un email correcto
                </div>
                <!-- DNI / NIE -->
                <div *ngIf="col['formControlName'] == 'dni' &&
                form[col['formControlName']].hasError('dniPatternError')">
                    Introduce un DNI o NIE válido
                </div>
                <!-- Password -->
                <div *ngIf="col['formControlName'] == 'password'">
                    <div *ngIf="form[col['formControlName']].hasError('invalidLength')">
                        La contraseña debe incluir al menos 8 caracteres
                    </div>
                    <div *ngIf="form[col['formControlName']].hasError('invalidCaps')">
                        La contraseña debe incluir al menos una mayúscula
                    </div>
                    <div *ngIf="form[col['formControlName']].hasError('invalidSmalls')">
                        La contraseña debe incluir al menos una minúscula
                    </div>
                    <div *ngIf="form[col['formControlName']].hasError('invalidNumbers')">
                        La contraseña debe incluir al menos un número
                    </div>
                </div>
                <div *ngIf="col['formControlName'] == 'confirmPassword'">
                    <div *ngIf="form[col['formControlName']].hasError('mustMatch')">
                        Las contraseñas deben coincidir
                    </div>
                </div>
                <!-- Phone number -->
                <div *ngIf="col['formControlName'] == 'phone'">
                    <div *ngIf="form[col['formControlName']].hasError('phoneNumberError')">
                        Debe introducir un número de teléfono válido
                    </div>
                </div>
                <!-- Zip Code -->
                <div *ngIf="col['formControlName'] == 'cp'">
                    <div *ngIf="form[col['formControlName']].hasError('minlength') ||
                    form[col['formControlName']].hasError('maxlength')">
                        El código postal debe contener 5 dígitos
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<app-modal [attr.id]="modalId" [modalId]="modalId" [closeAction]="closeAction"
           class="d-none">
    <div
        class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-12 offset-0 text-center message-container my-5">
        <p>{{textMessage}}</p>
        <button *ngIf="showModalButton" class="button-modal btn btn-primary" (click)="this[buttonAction](buttonParam)">
            {{buttonMessage}}
        </button>
    </div>
</app-modal>
<app-loader *ngIf="showLoader"></app-loader>
